<template>
  <v-dialog persistent v-model="isOpen" max-width="700px">
    <v-card v-if="packageHasPredefinedActivities">
      <v-card-title>
        <span class="headline"> Package Settings </span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout column>
            <v-layout wrap>
              <v-flex xs6>
                <h3>Display Settings</h3>
                <content-field
                  label="Name"
                  v-model="item.name"
                  @input="$v.item.name.$touch"
                  @blur="$v.item.name.$touch"
                  :error="$v.item.name"
                ></content-field>
                <content-field
                  label="Title"
                  v-model="item.title"
                ></content-field>
              </v-flex>
              <v-flex xs4 offset-xs1 class="my-4">
                <h3>Status</h3>
                <v-switch
                  v-model="item.status"
                  true-value="Enabled"
                  false-value="Disabled"
                  :label="item.status"
                />
              </v-flex>
            </v-layout>

            <v-layout row wrap mt-5>
              <v-flex xs5>
                <v-select
                  label="Package type"
                  :items="packagesType"
                  auto
                  v-model="item.type"
                ></v-select>
              </v-flex>
              <v-flex xs5 offset-xs1>
                <content-field
                  label="Price"
                  v-show="item.type !== 'Free'"
                  v-model="item.price"
                  @input="$v.item.price.$touch"
                  @blur="$v.item.price.$touch"
                  :error="$v.item.price"
                ></content-field>
              </v-flex>
            </v-layout>


            <v-layout wrap>
              <v-flex xs5>
                <content-field
                  label="Message limit"
                  v-model="item.messagesLimit"
                  @input="$v.item.messagesLimit.$touch"
                  @blur="$v.item.messagesLimit.$touch"
                  :error="$v.item.messagesLimit"
                ></content-field>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs12>
                <v-layout row wrap>
                  <v-flex xs2 d-flex class="my-4">
                    <h3>Package type:</h3>
                  </v-flex>
                  <v-flex xs3 d-flex class="my-4">
                      <v-checkbox
                        v-model="item.isInvitationPackage"
                        label="Is invitation package"
                      />
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs12>
                <v-layout row wrap>
                  <v-flex xs2 d-flex class="my-4">
                    <h3>Visibility:</h3>
                  </v-flex>
                  <v-flex xs3 d-flex class="my-4">
                    <v-checkbox
                      label="Public"
                      value="Public"
                      v-model="item.visibility"
                      :error="$v.item.visibility.$error"
                    />
                    <v-checkbox
                      label="Category"
                      value="Category"
                      v-model="item.visibility"
                      :error="$v.item.visibility.$error"
                    />
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 v-if="isVisibilityPublic">
                <v-layout row wrap>
                  <v-flex xs2 d-flex class="my-4">
                    <h3>Available attendee type:</h3>
                  </v-flex>
                  <v-flex xs3 d-flex class="my-4">
                    <v-checkbox
                      label="Buy"
                      value="Buy"
                      v-model="item.availableAttendeeType"
                    />
                    <v-checkbox
                      label="Sell"
                      value="Sell"
                      v-model="item.availableAttendeeType"
                    />
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>

            <v-layout column mt-3>
              <h3>Email Templates</h3>
              <v-layout wrap>
                <v-flex xs5>
                  <v-select
                    :items="registrationSuccesTemplatesList"
                    v-model="item.confirmationEmailTemplateName"
                    :error-messages="isValid($v.item.confirmationEmailTemplateName)"
                    label="Confirmation Template"
                    item-value="templateKey"
                    item-text="templateKey"
                  />
                  <v-select
                    :items="registrationFailtureTemplatesList"
                    v-model="item.failedPaymentEmailTemplateName"
                    :error-messages="isValid($v.item.failedPaymentEmailTemplateName)"
                    label="Failed Payment Template"
                    item-value="templateKey"
                    item-text="templateKey"
                  />
                  <v-select
                    :items="multipleTicketsSuccessBuyTemplatesList"
                    v-model="item.multiUserConfirmationEmailTemplateKey"
                    :error-messages="isValid($v.item.multiUserConfirmationEmailTemplateKey)"
                    label="Multiple user confirmation email template"
                    item-value="templateKey"
                    item-text="templateKey"
                  />
                  <v-select
                    :items="multipleTicketsFailedBuyTemplatesList"
                    v-model="item.multiUserFailedPaymentEmailTemplateKey"
                    label="Multiple user failed email template"
                    item-value="templateKey"
                    item-text="templateKey"
                  />

                </v-flex>

              </v-layout>
            </v-layout>

            <v-layout wrap mt-5>
              <v-flex xs12>
                <h3>Predefined activities </h3>
                <v-layout row wrap class="my-4">
                  <v-flex
                    fluid
                    xs6
                    v-for="(value, index) in packagePredefinedActivities"
                    :key="`predefined-activitie-${value.title}-${index}`"
                  >
                    <v-checkbox
                      :label="value.title"
                      v-model="item.predefinedActivities[index]"
                      :true-value="value.id"
                      :error="$v.item.predefinedActivities.$error"
                    />
                  </v-flex>
                </v-layout>
              </v-flex>

            </v-layout>
            <v-layout wrap mt-5>
              <v-flex xs12>
                <killer-feature
                  ref="formKillerFeature"
                  :data="item.killerFeatureDisplaySetting"
                />
              </v-flex>
            </v-layout>
          </v-layout>
          <small v-if="isRequiredMessage">*indicates required field</small>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" flat="flat" @click.native="close">Cancel</v-btn>
        <v-btn
          color="blue darken-1"
          flat="flat"
          :disabled="disabledButton"
          @click.native="addPackage"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-card v-else>
      <v-card-title class="headline">Could not add package</v-card-title>
      <v-card-text>
        No predefined activity displayed for package. Please check "Package" on "Predefined Activities" tab.
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="green darken-1"
          flat="flat"
          @click="goToPredefinedActivities"
        >
          Add
        </v-btn>
      </v-card-actions>
    </v-card>

  </v-dialog>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import { clone, merge, path, pathOr } from 'ramda'
  import { numeric, required, minValue } from 'vuelidate/lib/validators'
  import mixins from '@/utils/mixins'
  import KillerFeature from './killerFeature.vue'

  const defaultItem = {
    name: '',
    title: '',
    price: 100,
    type: 'Paid',
    status: 'Enabled',
    visibility: 'Public',
    messagesLimit: 60,
    confirmationEmailTemplateName: '',
    failedPaymentEmailTemplateName: '',
    availableAttendeeType: ['Buy'],
    predefinedActivities: [],
    killerFeatureDisplaySetting: null,
    multiUserFailedPaymentEmailTemplateKey: '',
    multiUserConfirmationEmailTemplateKey: ''
  }

  const validationTemplate = {
    name: { required },
    // subtitle: { required },
    visibility: { required },
    type: { required },
    confirmationEmailTemplateName: { required },
    failedPaymentEmailTemplateName: { required },
    predefinedActivities: { required },
    messagesLimit: { required, numeric },
    multiUserConfirmationEmailTemplateKey: { required }
  }

  export default {
    name: 'PackageModal',
    mixins: [mixins.isWriteAvailable, mixins.emailTemplates],
    components: {
      KillerFeature
    },
    props: {
      showModal: {
        type: Boolean
      }
    },
    data () {
      return {
        defaultItem,
        item: clone(defaultItem),
        isOpen: false,
        disabledButton: false,
        isRequiredMessage: false,
        packagesType: ['Free', 'Paid', 'Contract'],
        // DON'T DELETE! need for isWriteAvailable mixin
        scopeForWrite: 'registration:write'
      }
    },
    validations () {
      return {
        item: {
          ...validationTemplate,
          price: pathOr('', ['type'], this.item).toLowerCase() !== 'free' ? { required, numeric, minValue: minValue(1) } : { numeric }
        }
      }
    },
    computed: {
      ...mapGetters(['predefinedActivity']),
      isVisibilityPublic () {
        return path(['visibility'], this.item) === 'Public'
      },
      packagePredefinedActivities () {
        return this.predefinedActivity.filter((activity) => activity.activityDisplayLocation.includes('Package'))
      },
      packageHasPredefinedActivities () {
        return !!this.packagePredefinedActivities.length
      }
    },
    watch: {
      isOpen (val) {
        if (!val) this.close()
      }
    },
    methods: {
      ...mapActions([
        'addPackageList',
        'showResultSuccessMessage',
        'showResultErrorMessage'
      ]),
      goToPredefinedActivities () {
        this.close()
        this.$router.push({ path: '/packages/predefined'})
      },
      isValid (validationItem) {
        return validationItem.$dirty && validationItem.$invalid
          ? ['This field is required']
          : []
      },
      close () {
        this.$v.item.$reset()
        this.$emit('close')
      },
      async addPackage () {
        this.disabledButton = true
        try {
          if (this.item.type === 'Free') {
            this.item.price = null
          }
          const killerFeatureDisplaySetting = this.$refs.formKillerFeature.submitForm()
          this.$v.item.$touch()
          if (this.$v.item.$invalid) return
          await this.preSubmitPackage(killerFeatureDisplaySetting)
          this.close()
        } catch (err) {
          const error = err.response ? err.response.data : {}
          if (error.Code === 'validation.base-0001') {
            const pattern = RegExp('PackageEmailTemplateKeysValidatorBase-00(2|3|4)')
            const emailTemaplatenotChosenErr = error.ValidationFailures.filter(failure => pattern.test(failure.errorCode))
            emailTemaplatenotChosenErr.length ? this.showResultErrorMessage('Missing email template for listing. Either pick it or deselect corresponding activity(-ies)') : this.showResultErrorMessage('Validation error occured. Package wasn\'t saved')
          }
          throw err
        } finally {
          this.disabledButton = false
        }
      },
      async preSubmitPackage (killerFeatureDisplaySetting) {
        try {
          let item = null
          if (!!path(['metadataObject', 'isKillerFeatureEnabled'], killerFeatureDisplaySetting)) {
            item = merge(this.item, { killerFeatureDisplaySetting })
          } else {
            item = clone(this.item)
            item.killerFeatureDisplaySetting = null
          }
          item.predefinedActivities = item.predefinedActivities.map((v, i) => v ? this.packagePredefinedActivities[i].id : null).filter(i => i)
          if (this.isVisibilityPublic) item.availableAttendeeType = item.availableAttendeeType.join(', ')
          await this.submitPackage(item)
        } catch (err) {
          throw err
        }
      },
      async submitPackage (item) {
        try {
          await this.addPackageList(item)
          this.showResultSuccessMessage('Package added successful')
          this.$emit('successSendPackage')
        } catch (err) {
          throw err
        }
      }
    },
    created () {
      this.isOpen = this.showModal
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/Packages/packageModal.vue